
import ReactDOM from 'react-dom';
import React from 'react';
import Header from './Components/Header/header';
import Navbar from './Components/Navbar/navbar';
import Footer from './Components/Footer/footer';
import Section from './Components/Section/section';
import SectionSell from './Components/Section/section_sell';
import NPSCalc from './Components/NPSCalc/npscalc';


let App = (
    <div>
        <div>
            <Navbar />
            <div>
                <Header/>
                <NPSCalc />
                <div className="content area">
                    <div className="container">
                        <section className="about-area section-white-bg" id="about-area">
                            <div className="feature section-padding" id="feature">
                                <div className="container">
                                    <Section />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <div className="content sell">
                    <div className="container">
                        <section><SectionSell /></section>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
);

ReactDOM.render(App, document.getElementById('app'));
